import React, { useEffect, useState } from "react";
import LeftBar from "./left-side-bar";
import MainHomeContent from "./main-content";
import RightBar from "./right-side-bar";
import { useAppSelector } from "../../hooks/store-hooks";
import { useLazyGetUserByIdDataQuery } from "../../store/api/userApi";
import SignUpAnimation from "../common/animations/sign-up-animation";
import { getLocalStorage, setLocalStorage } from "../../helpers/storage";

const HomePage = () => {
  const { homeData } = useAppSelector((state: any) => state.home ?? {});

  const user = homeData?.user ?? {};
  const [topicsQueryString, settopicsQueryString] = useState<string>("");
  const [trigger] = useLazyGetUserByIdDataQuery();
  const [showAnimation, setShowAnimation] = useState(false);

  useEffect(() => {
    if (user?._id) {
      trigger({ userId: user?._id });
    }
  }, [user?._id]);

  useEffect(() => {
    const hasShownAnimation = getLocalStorage("hasShownAnimation");
    if (!hasShownAnimation) {
      setShowAnimation(true);
      setLocalStorage("hasShownAnimation", "true");

      setTimeout(() => {
        setShowAnimation(false);
      }, 6000);
    }
  }, []);

  return (
    <div className="bg-gray-100 min-h-[100vh] overflow-y-auto">
      <div className="p-4">
        <div className="mx-5 grid grid-cols-1 lg:grid-cols-12 gap-4">
          {/* Left Sidebar */}
          <LeftBar setTopicsQueryString={settopicsQueryString} />

          {/* Main Content */}
          <MainHomeContent topicsQueryString={topicsQueryString} />

          {/* Right Sidebar */}
          <RightBar />
        </div>
      </div>
      {showAnimation && <SignUpAnimation />}
    </div>
  );
};

export default HomePage;
